<script setup lang="ts">
import type { ConfiguratorPoolLine } from '~/models/configurator/configuratorPoolLine.model'

interface Props {
  poolLines: ConfiguratorPoolLine[]
  currentPoolLine: ConfiguratorPoolLine | null
}
const props = defineProps<Props>()

const emits = defineEmits<{
  selectPoolLine: [ConfiguratorPoolLine]
}>()

const { dt } = useDirectusTranslation()

function selectPoolLine(poolLine: ConfiguratorPoolLine) {
  emits('selectPoolLine', poolLine)
}

function poolLineIsActive(poolLine: ConfiguratorPoolLine) {
  return poolLine.id === props.currentPoolLine?.id
}

const selectedPoolLine = computed<ConfiguratorPoolLine | null>({
  get: () => props.currentPoolLine,
  set: (value) => {
    if (value)
      selectPoolLine(value)
  },
})
</script>

<template>
  <div class="container mx-auto flex-none items-center gap-4 px-8 py-2">
    <div class="hidden items-center justify-evenly gap-4 lg:flex">
      <div v-for="poolLine in props.poolLines" :key="poolLine.id">
        <AppButton
          variant="slider"
          :is-active="poolLineIsActive(poolLine)"
          @click="selectedPoolLine = poolLine"
        >
          {{ dt(poolLine.translations)?.name }}
        </AppButton>
      </div>
    </div>
  </div>
</template>
